namespace AgerLMS {
    export enum BundleTypes {
        BasicPackage = 0,
        ClinicalPackage = 1,
        FullPackage = 2,
        ComboPackages = 3,
        AllInclusivePackage = 4,
        FullPackageWithBook = 5
    }
    Serenity.Decorators.registerEnumType(BundleTypes, 'AgerLMS.BundleTypes');
}
